import { render, staticRenderFns } from "./DocumentListBody.vue?vue&type=template&id=df40d728&scoped=true&"
import script from "./DocumentListBody.vue?vue&type=script&lang=js&"
export * from "./DocumentListBody.vue?vue&type=script&lang=js&"
import style0 from "./DocumentListBody.vue?vue&type=style&index=0&id=df40d728&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df40d728",
  null
  
)

export default component.exports